export default __webpack_public_path__ + "static/media/Boots of Concealing Shadows.95ddfbb9.jpg";